import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getDaysDifference } from '../../utils';
import './DaysDifference.scss';

export const DaysDifference = () => {
  const [dateOne, setDateOne] = useState(() => new Date('1990-01-01'));
  const [dateTwo, setDateTwo] = useState(() => new Date('1997-05-11'));
  const [diff, setDiff] = useState(() => getDaysDifference(dateOne, dateTwo));
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setDiff(getDaysDifference(dateOne, dateTwo));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [dateOne, dateTwo]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Days Difference Calculator</h2>
        <p className='mb-4'>
          Calculate how many days there are between two given dates
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select The First Date'
            initDate={dateOne}
            setDate={setDateOne}
          />
          <DateSelector
            label='Select The Second Date'
            initDate={dateTwo}
            setDate={setDateTwo}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p className='mb-0' dangerouslySetInnerHTML={{ __html: diff }} />
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
